module.exports = __webpack_public_path__ + "img/big.be5030ca.webp";